import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { CommonModule, NgIf } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
export interface SharedDialogOptions {
  titleIcon?: string;
  titleIconColor?: 'primary' | 'secondary' | 'danger';
  subTitle?: string;
  confirmText?: string;
  confirmIcon?: string;
  confirmIconColor?: string;
  confirmButtonStyle?: 'primary' | 'primary-btn' | 'danger' | 'danger-btn' | 'ai';
  confirmIconPosition?: 'start' | 'end';
  confirmDisabled?: boolean;
  cancelText?: string;
  cancelButtonStyle?: 'secondary' | 'secondary-btn' | 'danger' | 'danger-btn' | 'transparent';
  middleText?: string;
  middleIcon?: string;
  middleButtonStyle?: 'secondary' | 'secondary-btn' | 'transparent' | 'danger' | 'danger-btn';
  size?: 'small' | 'medium' | 'large' | 'auto';
  hideHeader?: boolean;
  confirmLoading?: boolean;
  disableConfirm?: boolean;
  isSaving?: boolean;
  hideConfirmButton?: boolean;
  hideCloseButton?: boolean;
  hideActions?: boolean;
  customConfirmButton?: boolean;
  hideConfirm?: boolean;
}

@Component({
  selector: 'app-shared-dialog',
  standalone: true,
  templateUrl: './shared-dialog.component.html',
  imports: [NgIf, ButtonComponent, SvgIconComponent, TranslateModule],
  styleUrls: ['./shared-dialog.component.scss']
})
export class SharedDialogComponent implements OnInit, OnChanges {

  @Input() title!: string;
  @Input() options: SharedDialogOptions = {
    titleIcon: '',
    subTitle: '',
    titleIconColor: 'secondary',
    confirmText: '',
    confirmIcon: '',
    confirmButtonStyle: 'primary',
    confirmIconPosition: 'start',
    confirmDisabled: false,
    cancelText: '',
    cancelButtonStyle: 'secondary',
    size: 'medium',
    hideHeader: false,
    confirmLoading: false,
    disableConfirm: false,
    isSaving: false,
    hideActions: false,
    hideConfirmButton: false,
    hideCloseButton: false,
    customConfirmButton: false,
    hideConfirm: false
  };

  @Output() confirm = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();
  @Output() middle = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    const defaultOptions: SharedDialogOptions = {
      titleIcon: '',
      titleIconColor: 'secondary',
      confirmText: '',
      confirmIcon: '',
      confirmButtonStyle: 'primary-btn',
      confirmIconPosition: 'start',
      cancelText: '',
      cancelButtonStyle: 'secondary-btn',
      size: 'medium',
      hideHeader: false,
      hideActions: false,
      customConfirmButton: false,
      hideConfirmButton: false,
      hideCloseButton: false,
      confirmLoading: false,
      disableConfirm: false,
      isSaving: false
    };
    
    this.options = { ...defaultOptions, ...this.options };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.options = changes['options'].currentValue;
    }
  }

  get width() {
    switch (this.options.size) {
      case 'small':
        return '400px';
      case 'medium':
        return '700px';
      case 'large':
        return '900px';
      case 'auto':
        return 'auto';
      default:
        return '600px';
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }

  onMiddle() {
    this.middle.emit();
  }
}
